import $ from "jquery";

const toggle = () => {
  const init = () => {
    execute();
    toggleOpen();
    slide();
  };

  const execute = () => {
    const el = {
      main: ".js-toggle",
    };

    if ($(el.main).length === 0) return;

    $(document).on("click", el.main, function () {
      const target = $(this).data("target");

      const thisCheck = $(this).attr("open");
      if (!thisCheck) $(this).attr("open", "");
      else $(this).removeAttr("open");

      $(target).toggle(300);
    });
  };

  const slide = () => {
    const el = {
      main: ".js-toggle-slide",
    };

    if ($(el.main).length === 0) return;

    $(document).on("click", el.main, function () {
      const target = $(this).data("target");

      const thisCheck = $(this).attr("open");
      if (!thisCheck) $(this).attr("open", "");
      else $(this).removeAttr("open");

      $(target).slideToggle(300);
    });
  };

  const toggleOpen = () => {
    const el = {
      main: ".js-toggle-open",
    };

    if ($(el.main).length === 0) return;

    $(document).on("click", el.main, function () {
      const target = $(this).data("target");
      const thisCheck = $(target).attr("open");
      if (!thisCheck) $(target).attr("open", "");
      else $(target).removeAttr("open");
    });
  };
  init();
};

try {
  toggle();
} catch (error) {
  console.error("toggle", error);
}
